/**
 * store invoice infomation
 */
import Vue from "vue";
import moment from "moment";

import CommonService from "@/core/utils/common-service";

function initialState() {
  return {
    // インボイス発行情報
    invoice: {
      // 基本設定情報
      basicInfo: null,
      // 輸入者情報
      consigneeInfo: null,
      // 輸出者情報
      shipperInfo: null,
      // 出荷予定個数
      pcs: null,
      // クール区分
      coolDiv: null,
      // クール区分ラベル
      coolDivLabel: null,
      // 荷物設定情報
      packageInfo: null
    },

    countryList: [],
    stateList: [],
    listTaxIdInfo: [],
    listPaidFreeKbn: [],
    listCoolKbn: [],
    listOriginCountry: [],
    listUnit: [],
    currencyCd: {},
    shipmentTerm: {},
    weightUnidCd: {},
    listDestinationState: [],
    listVatRegisterDiv: [],
    listVatRegisterNotice: [],
    listVatRegisterHint: []
  };
}

function setProperties(state, data) {
  if (data.takkyubinCountryResponse) {
    state.countryList =
      data.takkyubinCountryResponse.takkyubinCountryList || [];
  }
  if (data.upsCountryResponse) {
    state.stateList = data.upsCountryResponse.countryList || [];
  }

  if (data.originCountryResponse) {
    state.listOriginCountry =
      data.originCountryResponse.originCountryList || [];
  }
  if (data.unitResponse) {
    state.listUnit = data.unitResponse.unitList || [];
  }
}

const getters = {
  invoice: state => state.invoice,
  listCountry: state => state.countryList,
  listState: state => state.stateList,
  listTaxIdInfo: state => state.listTaxIdInfo,
  listPaidFreeKbn: state => state.listPaidFreeKbn,
  listCoolKbn: state => state.listCoolKbn,
  listOriginCountry: state => state.listOriginCountry,
  listUnit: state => state.listUnit,
  currencyCd: state => state.currencyCd,
  shipmentTerm: state => state.shipmentTerm,
  weightUnidCd: state => state.weightUnidCd,
  listDestinationState: state => state.listDestinationState,
  listVatRegisterDiv: state => state.listVatRegisterDiv,
  listVatRegisterNotice: state => state.listVatRegisterNotice,
  listVatRegisterHint: state => state.listVatRegisterHint
};

const mutations = {
  setInvoiceInfo(state, invoice) {
    if (invoice) {
      // インボイス発行情報
      // 基本設定情報
      state.invoice.basicInfo = invoice.basicInfo || null;
      // 輸入者情報
      state.invoice.consigneeInfo = invoice.consigneeInfo || null;
      // 輸出者情報
      state.invoice.shipperInfo = invoice.shipperInfo || null;
      // 出荷予定個数
      state.invoice.pcs = invoice.pcs;
      // クール区分
      state.invoice.coolDiv = invoice.coolDiv;
      // クール区分ラベル
      state.invoice.coolDivLabel = invoice.coolDivLabel;
      // VAT種類
      state.invoice.vatRegisterDiv = invoice.vatRegisterDiv;
      // VAT種類（表示用）
      state.invoice.vatRegisterDivName = invoice.vatRegisterDivName;
      // VAT番号
      state.invoice.vatRegisterNumber = invoice.vatRegisterNumber;
      // 荷物設定情報
      state.invoice.packageInfo = invoice.packageInfo || null;
    }
  },
  setInitData(state, data) {
    if (data.taxIdInfoResponse) {
      state.listTaxIdInfo = data.taxIdInfoResponse.taxIdInfoList || [];
    }
    state.listPaidFreeKbn = getItemInfo("paidFreeKbn", data);
    state.listCoolKbn = getItemInfo("coolKbn", data);

    const currencyCd = getItemInfo("currencyCd", data);
    state.currencyCd = currencyCd && currencyCd[0];

    const shipmentTerm = getItemInfo("shipmentTerm", data);
    state.shipmentTerm = shipmentTerm && shipmentTerm[0];

    const weightUnidCd = getItemInfo("weightUnidCd", data);
    state.weightUnidCd = weightUnidCd && weightUnidCd[0];

    state.listVatRegisterDiv = getItemInfo("vatRegisterDiv", data);
    state.listVatRegisterNotice = getItemInfo("vatRegisterDivNotice", data);
    state.listVatRegisterHint = getItemInfo("vatRegisterDivHint", data);

    setProperties(state, data);
  },
  resetState(state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  updateBasicInfo(state, newValue) {
    const _basicInfo = state.invoice.basicInfo;
    _basicInfo.referenceNo = newValue.referenceNo;
    _basicInfo.shippingDate = newValue.shippingDate;
  },
  updateConsigneeInfo(state, newVal) {
    const _consigneeInfo = state.invoice.consigneeInfo;
    _consigneeInfo.consigneeAddress1 = newVal.state && newVal.state.stateName;
    _consigneeInfo.consigneeAddress2 = newVal.cityCode;
    _consigneeInfo.consigneeAddress3 = newVal.address;
    _consigneeInfo.consigneeAddress4 = newVal.companyName;
    _consigneeInfo.consigneeCountryCd =
      newVal.country && newVal.country.countryCd;
    _consigneeInfo.consigneeCountryEng =
      newVal.country && newVal.country.countryEng;
    _consigneeInfo.consigneeCountryNm =
      newVal.country && newVal.country.countryNm;
    _consigneeInfo.consigneeName = newVal.name;
    _consigneeInfo.consigneePhone = newVal.phoneNumber;
    _consigneeInfo.consigneeUsciOcCd = newVal.ocUsciCd;
    _consigneeInfo.consigneeUsciOcDiv = newVal.usciOcKbn;
//    _consigneeInfo.consigneeUsciOcDivLabel =
//      newVal.usciOcKbn && newVal.usciOcKbn.stringValue;
    _consigneeInfo.consigneeZip = newVal.postalCode;
    _consigneeInfo.stateCd = newVal.state && newVal.state.stateCd;
  },
  updateShipperInfo(state, newVal) {
    const _shipperInfo = state.invoice.shipperInfo;
    _shipperInfo.shipperAddress1 = newVal.prefectures;
    _shipperInfo.shipperAddress2 = newVal.cityWard;
    _shipperInfo.shipperAddress3 = newVal.street;
    _shipperInfo.shipperAddress4 = newVal.clientCompanyName;
    _shipperInfo.shipperName = newVal.clientName;
    _shipperInfo.shipperOrganizationCd = newVal.corporateNumber;
    _shipperInfo.shipperPhone = newVal.clientPhoneNumber;
    _shipperInfo.shipperZip = newVal.clientPostalCode;
  },
  updatePackageInfo(state, newVal) {
    const _packageInfo = state.invoice.packageInfo;
    _packageInfo.forEach(item => {
      item.currencyCd = newVal.currencyCd && newVal.currencyCd.stringValue;
      item.grossWeight = newVal.grossWeight;
      item.itemTotal = newVal.totalProductPrice;
      item.netWeight = newVal.netWeight;
      item.note1 = newVal.note1;
      item.note2 = newVal.note2;
      item.paidDiv = newVal.paidFreeKbn && newVal.paidFreeKbn.sbtNaiID;
      item.paidDivLabel = newVal.paidFreeKbn && newVal.paidFreeKbn.stringValue;
      item.shipmentTerm =
        newVal.shipmentTerm && newVal.shipmentTerm.stringValue;
      item.weightUnitCd = newVal.weightUnidCd && newVal.weightUnidCd.sbtNaiID;
      item.itemInfo = newVal.listItems.map(item => {
        return {
          itemCd: item.itemCd,
          itemName: item.itemName,
          hsCd: item.hsCd,
          originCountryId:
            item.originCountry && item.originCountry.originCountryId,
          originCountryName:
            item.originCountry && item.originCountry.originCountryName,
          valueOfUnit: item.valueOfUnit,
          unitCd: item.unit && item.unit.unitCd,
          unitName: item.unit && item.unit.unitName,
          quantity: item.quantity
        };
      });
    });
    state.invoice.pcs = newVal.shipmentQuantity;
    state.invoice.coolDiv = newVal.coolKbn && newVal.coolKbn.sbtNaiID;
    state.invoice.coolDivLabel = newVal.coolKbn && newVal.coolKbn.stringValue;
  },
  setDestinationStateByCountry(state, data) {
    const countries = data.countryList && data.countryList[0];
    const states = countries && countries.stateList;
    const cities = states && states[0].cityList;
    if (cities) {
      state.listDestinationState = cities.map(item => {
        return {
          name: item.cityName
        };
      });
    }
  }
};

const actions = {
  initInvoiceStore({ commit }, invoiceInfo) {
    if (invoiceInfo) {
      commit("setInvoiceInfo", invoiceInfo);
    }
  },
  resetStore({ commit, state }) {
    commit("resetState", state);
  },
  // ユーザ情報を取得
  async init({ commit }, params) {
    const { callBack, errorCallBack } = params;
    await Vue.axios
      .get("/kyg060001/init")
      .then(response => {
        const data = response.data;
        if (data) {
          commit("setInitData", data);
          callBack && callBack(response);
        }
      })
      .catch(err => {
        errorCallBack && errorCallBack(err);
      });
  },
  getDestinationStates({ commit }, params) {
    return new Promise(res => {
      const postBody = {
        countryCd: params.countryCd,
        stateCd: params.stateCd
      };
      Vue.axios
        .post("/kyg021001/destination-state", postBody, {})
        .then(response => {
          const data = response && response.data;
          if (data) {
            commit("setDestinationStateByCountry", data);
            res();
          }
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  validateInvoice({ commit }, params) {
    return validateInvoice(params);
  }
};

function getItemInfo(key, data) {
  if (!data.generalItemResponse || !data.generalItemResponse.queriedItemsInfo) {
    return [];
  }
  const queriedItemsInfo = data.generalItemResponse.queriedItemsInfo;
  const sbtIDList = queriedItemsInfo.find(
    item => item.sbtID === key && item.sbtIDList
  );

  return sbtIDList ? sbtIDList.sbtIDList : [];
}

function validateInvoice(invoice) {
  const {
    basicInfo,
    consigneeInfo,
    shipperInfo,
    pcs,
    coolDiv,
    vatRegisterDiv,
    vatRegisterNumber,
    packageInfo,
    settingNo
  } = invoice;

  const packageInfoData = packageInfo[0];
  const body = {
    settingNo: settingNo,
    invoiceInfo: [
      {
        basicInfo: {
          referenceNo: basicInfo.referenceNo,
          shippingDate: basicInfo.shippingDate
            ? moment(basicInfo.shippingDate).format("YYYYMMDD")
            : ""
        },
        consigneeInfo: CommonService.mapOut(consigneeInfo, [
          "consigneeCountryNm",
          "consigneeCountryEng",
          "consigneeUsciOcDivLabel",
          "consigneeDivLabelForScreen",
          "consigneeUsciOcDivLabelForScreen",
          "consigneeCountryName"
        ]),
        shipperInfo: shipperInfo,
        pcs: pcs ? pcs : null,
        coolDiv: coolDiv ? coolDiv : null,
        vatRegisterDiv: vatRegisterDiv ? vatRegisterDiv : null,
        vatRegisterNumber: vatRegisterNumber ? vatRegisterNumber : null,
        packageInfo: packageInfoData
          ? [
              {
                grossWeight: packageInfoData.grossWeight,
                netWeight: packageInfoData.netWeight
                  ? packageInfoData.netWeight
                  : null,
                itemTotal: packageInfoData.itemTotal
                  ? packageInfoData.itemTotal
                  : null,
                paidDiv: packageInfoData.paidDiv,
                weightUnitCd: packageInfoData.weightUnitCd,
                currencyCd: packageInfoData.currencyCd,
                shipmentTerm: packageInfoData.shipmentTerm,
                note1: packageInfoData.note1 ? packageInfoData.note1 : null,
                note2: packageInfoData.note2 ? packageInfoData.note2 : null,
                itemInfo: packageInfoData.itemInfo.map(item => {
                  return {
                    itemCd: item.itemCd,
                    itemName: item.itemName,
                    hsCd: item.hsCd ? item.hsCd : null,
                    originCountryId: item.originCountryId,
                    valueOfUnit: item.valueOfUnit,
                    unitCd: item.unitCd,
                    quantity: item.quantity
                  };
                })
              }
            ]
          : null
      }
    ]
  };

  return Vue.axios.post("/kyg071001/validate-invoice", body);
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  mutations,
  actions
};
